import { IUser } from '@fff-web/fff-utilities';

export type SubscriptionType_State = `${IUser['subscriptionType']}_${IUser['subscriptionState']}`;
type SubscriptionStringCollection = Partial<Record<SubscriptionType_State, string>>;

export const PRICE_INCREASE = {
  increaseDate: 'Aug 4th, 2025',
  increaseHour: '10:00 a.m. PT',
  annual: {
    membership: {
      current: 219.99,
      new: 259.96,
    },
    box: {
      current: 54.99,
      new: 64.99,
    },
  },
  seasonal: {
    membership: {
      current: 69.99,
      new: 79.99,
    },
  },
};

export const getCurrentMembershipPrice = (subscriptionType: IUser['subscriptionType']): number => {
  return subscriptionType === 'ANNUAL'
    ? PRICE_INCREASE.annual.membership.current
    : PRICE_INCREASE.seasonal.membership.current;
};

const { annual, seasonal, increaseDate } = PRICE_INCREASE;

export const ratesDisclaimer: SubscriptionStringCollection = {
  ANNUAL_ACTIVE: `The Annual membership will increase to $${annual.membership.new} ($${annual.box.new} per box) on ${increaseDate}. Lock in your current price of $${annual.membership.current} ($${annual.box.current} per box) when you prepay for an additional four boxes!`,
  SEASONAL_ACTIVE: `The Seasonal membership will increase to $${seasonal.membership.new} per box on ${increaseDate}. Lock in your current price of $${seasonal.membership.current} when you prepay for your Fall Box!`,
  ANNUAL_CANCELED: `The Annual membership will increase to $${annual.membership.new} ($${annual.box.new} per box) on ${increaseDate}. Reactivate now and lock in your current price of $${annual.membership.current} ($${annual.box.current} per box) when you prepay for an additional four boxes!`,
  SEASONAL_CANCELED: `The Seasonal membership will increase to $${seasonal.membership.new} per box on ${increaseDate}. Reactivate now and lock in your current price of $${seasonal.membership.current} when you prepay for your Fall Box!`,
};

export const legalNote: SubscriptionStringCollection = {
  ANNUAL_ACTIVE: `By clicking “Purchase Now” you authorize FabFitFun to immediately charge $${annual.membership.current} USD to the payment method provided for an additional 4 boxes to your account. Your subscription will continue until canceled and you will be charged $${annual.membership.new} USD on your next billing date.`,
  SEASONAL_ACTIVE: `By clicking “Purchase Now” you authorize FabFitFun to immediately charge $${seasonal.membership.current} USD to the payment method provided for your Fall 2025 box. Your subscription will continue until canceled and you will be charged $${seasonal.membership.new} USD starting on your Winter 2025 billing date.`,
  ANNUAL_CANCELED: `By clicking “Purchase Now” you authorize FabFitFun to reactivate your subscription and immediately charge $${annual.membership.current} USD to the payment method provided for an additional 4 boxes to your account. Your subscription will continue until canceled and you will be charged $${annual.membership.new} USD on your next billing date.`,
  SEASONAL_CANCELED: `By clicking “Purchase Now” you authorize FabFitFun to reactivate your subscription and immediately charge $${seasonal.membership.current} USD to the payment method provided for your Fall 2025 box. Your subscription will continue until canceled and you will be charged $${seasonal.membership.new} USD starting on your Winter 2025 billing date.`,
};
